import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDropdownDTO, ITermState } from "../../../types/term/termInterfaces";

export const initialState: ITermState = {
  termDropdown: []
};

export const termSlice = createSlice({
  name: 'term',
  initialState,
  reducers: {
    loadingTermDropdown: (state, action: PayloadAction<IDropdownDTO[]>) => {
      state.termDropdown = action.payload;
    },
  }
});

export const { loadingTermDropdown } = termSlice.actions;
export default termSlice.reducer;
